export enum ToastEnum{
    shortDuration = 5000,
    mediumDuration = 10000,
    longDuration = 15000
}

export enum ToastPrimeSeverityEnum{
    SUCESSO = 'success',
    INFORMACAO = 'info',
    ATENCAO = 'warn',
    ERRO = 'error'
}

export enum ToastIonicSeverityEnum{
    SUCESSO = 'success',
    INFORMACAO = 'primary',
    ATENCAO = 'warning',
    ERRO = 'danger'
}